const getNavbarDimensions = () => {
  const header = document.querySelector('[data-esll-navbar]')

  return header?.getBoundingClientRect() || { height: 0, width: 0 }
}

export default function scrollToElement(
  element,
  { behavior = 'smooth', paddingTop = 20 } = {}
) {
  if (!element) {
    return
  }

  const headerHeight = getNavbarDimensions().height
  const newY = element.offsetTop - headerHeight - paddingTop

  try {
    window.scroll({
      left: 0,
      top: newY,
      behavior,
    })
  } catch {
    // just a fallback for older browsers
    window.scroll(0, newY)
  }
}
